import React, { useEffect, useState } from 'react';
import { client } from '../lib/sanityClient';

interface Event {
  _id: string;
  title: string;
  startDate: string;
  endDate: string;
}

const TestProgramme: React.FC = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // Simple direct query to fetch all events
    const fetchEvents = async () => {
      try {
        console.log('Fetching events directly from Sanity...');
        const result = await client.fetch<Event[]>(`*[_type == "event"]{_id, title, startDate, endDate}`);
        console.log('Raw events data:', result);
        setEvents(result || []);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError(err instanceof Error ? err : new Error(String(err)));
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return <div className="w-full h-screen flex items-center justify-center">Loading events directly...</div>;
  }

  if (error) {
    return <div className="w-full h-screen flex items-center justify-center text-red-600">
      Error loading events: {error.message}
    </div>;
  }

  if (!events || events.length === 0) {
    return <div className="w-full h-screen flex items-center justify-center">No events found (direct query)</div>;
  }

  return (
    <div className="min-h-screen bg-white pt-24">
      <div className="max-w-[2000px] mx-auto px-6">
        <h1 className="text-3xl font-bold mb-8">Test Programme - Direct Query</h1>
        
        <div className="space-y-8">
          {events.map(event => (
            <div key={event._id} className="border p-6 rounded-lg shadow-sm">
              <h2 className="text-2xl event-title">{event.title}</h2>
              <div className="mt-4">
                <p><strong>Start Date:</strong> {new Date(event.startDate).toLocaleDateString()}</p>
                {event.endDate && (
                  <p><strong>End Date:</strong> {new Date(event.endDate).toLocaleDateString()}</p>
                )}
                <p><strong>ID:</strong> {event._id}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestProgramme;
